import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';

export default function StatisticsCard({ label, statistic, icon: Icon, view = null }) {
    return <div className="portal-metric portal-commission-card"><span className="portal-metric-icon" aria-hidden="true"><Icon /></span><div><p>{label}</p><strong>{statistic ?? '—'}</strong>{view && <Link to={view} className="portal-report-link">View statement <FiArrowUpRight aria-hidden="true" /></Link>}</div></div>;
}
